import { createAppTRPC, createTRPCLinks } from '@xhubio-saas/core-frontend/kernel'
import type { AppRouter } from '@xhubio-saas/saas-invoice-api-backend/trpc'

/**
 * Typed tRPC React client bound to the saas-invoice-api-backend AppRouter.
 *
 * Replaces the previously untyped `trpc` from
 * `@xhubio-saas/core-frontend/kernel` (which is `: any` for backward
 * compatibility). New code should import from this file.
 *
 * TYPEN AKTUALISIEREN: `AppRouter` kommt aus dem **veröffentlichten**
 * Types-Only-Package (`dist/trpc/index.d.ts`). Nach einer Router-Änderung im
 * Backend gilt regulär: Version in `package.json` hochziehen + `pnpm install`.
 * Solange die neue Version noch nicht publiziert ist, hilft lokal:
 *
 *   cd ../saas-invoice-api-backend && npm run build:types
 *   cp -R dist "$(readlink -f node_modules/@xhubio-saas/saas-invoice-api-backend)/"
 *
 * (nur node_modules, KEIN `file:`/`link:` in der package.json — der nächste
 * `pnpm install` setzt den Stand der gepinnten Version wieder her).
 */
export const trpc = createAppTRPC<AppRouter>()

/** Standard transport links — apps wire trpc.createClient with these. */
export const trpcLinks = createTRPCLinks
